import React from 'react'
import { ProductsDashboard } from './components/ProductsDashboard'

const ProductsApp: React.FC = () => {
  return <ProductsDashboard />
}

export default ProductsApp